// src/tests/ChildTest/NonwordRepetition/assets.js
import {Howl} from 'howler';

// ---------- CHILD NO – TEST NONWORDS ----------

// Basic objects (the mug, chair, house etc.)
import imgHouse from '../../assets/images/house2.png';
import imgBag from '../../assets/images/bag.png';
import imgWhale from '../../assets/images/whale.png';
import imgSheep from '../../assets/images/sheep.png';
import imgGiraffe from '../../assets/images/giraffe.png';

// Row of new images you showed (adjust paths as needed)
import imgTriangle from '../../assets/images/Triangle.png';
import imgSquare from '../../assets/images/Square.png';
import imgCircle from '../../assets/images/Circle.png';
import imgOrange from '../../assets/images/Orange.png';
import imgPear from '../../assets/images/Pear.png';
import imgPineapple from '../../assets/images/Pineapple.png';
import imgGrapes from '../../assets/images/Grapes.png';
import imgFlower from '../../assets/images/Flower2.png';
import imgDog from '../../assets/images/Dog.png';
import imgCat from '../../assets/images/Cat2.png';
import imgCars from '../../assets/images/Cars.png';
import imgCarsBike from '../../assets/images/CarsAndBicycle.png';
import imgBus from '../../assets/images/Bus.png';
import imgBooks from '../../assets/images/Books.png';
import imgBird from '../../assets/images/Bird.png';
import imgBanana from '../../assets/images/Banana2.png';
import imgBall from '../../assets/images/Ball2.png';
import imgApple from '../../assets/images/Apple2.png';

/* import nw1 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-1.mp3';
import nw2 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-2.mp3';
import nw3 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-3.mp3';
import nw4 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-4.mp3';
import nw5 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-5.mp3';
import nw6 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-6.mp3';
import nw7 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-7.mp3';
import nw8 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-8.mp3';
import nw9 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-9.mp3';
import nw10 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-10.mp3';
import nw11 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-11.mp3';
import nw12 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-12.mp3';
import nw13 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-13.mp3';
import nw14 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-14.mp3';
import nw15 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-15.mp3';
import nw16 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-16.mp3'; */

//Discraction Voiceovers
import noDistraction1ClapHandsAsShownOnScreen from '../../assets/sounds/se/nonwordRepetition/distractions/1-Klapp (1).mp3';
import noDistraction2SayColoursAsShownOnScreen from '../../assets/sounds/se/nonwordRepetition/distractions/2-Fargene (1).mp3';
import noDistraction3SayNumberAsShownOnScreen from '../../assets/sounds/se/nonwordRepetition/distractions/3-Tall (1).mp3';
import noDistraction4FourThingsWithSameShapeAsShownOnScreen from '../../assets/sounds/se/nonwordRepetition/distractions/4 things that has the same shape.mp3';
import noDistraction5NameFourAnimalsQuckly from '../../assets/sounds/se/nonwordRepetition/distractions/Animals.mp3';
import noDistraction6ThreeSameColoursItemsAsShownOnScreen from '../../assets/sounds/se/nonwordRepetition/distractions/Items in same color.mp3';
import noDistraction7NameItemsAsShownOnScreen from '../../assets/sounds/se/nonwordRepetition/distractions/Name items.mp3';
import noDistraction8CorrectOrderFromBigToSmall from '../../assets/sounds/se/nonwordRepetition/distractions/Name items in order from biggest to smallest.mp3';
import noDistraction9SolveAssignmnet from '../../assets/sounds/se/nonwordRepetition/distractions/1-4-adp9Bwg9.mp3';

/* import nnDistraction1ClapHandsAsShownOnScreen from '../../assets/sounds/se/nonwordRepetition/distractions/1-NN-Klapp.mp3';
import nnDistraction2SayColoursAsShownOnScreen from '../../assets/sounds/se/nonwordRepetition/distractions/2-NN-Farger .mp3';
import nnDistraction3SayNumberAsShownOnScreen from '../../assets/sounds/se/nonwordRepetition/distractions/3-NN-Tall .mp3';
import nnDistraction4FourThingsWithSameShapeAsShownOnScreen from '../../assets/sounds/se/nonwordRepetition/distractions/Name items with the same shape.mp3';
import nnDistraction5NameFourAnimalsQuckly from '../../assets/sounds/se/nonwordRepetition/distractions/Animals.mp3';
import nnDistraction6ThreeSameColoursItemsAsShownOnScreen from '../../assets/sounds/se/nonwordRepetition/distractions/items in the same color.mp3';
import nnDistraction7NameItemsAsShownOnScreen from '../../assets/sounds/se/nonwordRepetition/distractions/Name items.mp3';
import nnDistraction8CorrectOrderFromBigToSmall from '../../assets/sounds/se/nonwordRepetition/distractions/Name items in order from biggest to smallest.mp3';
import nnDistraction9SolveAssignmnet from '../../assets/sounds/se/nonwordRepetition/distractions/2-2-GKOLpGmm.mp3'; */

// If 17 is also a test item, we can enable this later:
// import nw17 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-17.mp3';

// generic “Say the word again” for test
import sayAgainTest from '../../assets/sounds/se/nonwordRepetition/adult/test/Si-ordet-en-gang-til.mp3';

// ---------- CHILD NO – TRIAL ----------

/* import trial1 from '../../assets/sounds/se/nonwordRepetition/child/trial/trial1.mp3';
import trial1Correct from '../../assets/sounds/se/nonwordRepetition/child/trial/trial1-if-correct.mp3';
import trial1Wrong from '../../assets/sounds/se/nonwordRepetition/child/trial/trial1-if-wrong.mp3';
import trial1NoAnswer10s from '../../assets/sounds/se/nonwordRepetition/child/trial/trial-1-after10sec-if-they-dont-rememeber.mp3';
import trial1Wrong10s from '../../assets/sounds/se/nonwordRepetition/child/trial/TRIAL1-after-10-sek-if-wrong.mp3'; */

import sayAgainTrial from '../../assets/sounds/se/nonwordRepetition/adult/trial/Si-ordet-en-gang-til.mp3';
/* import introAfterTrial from '../../assets/sounds/se/nonwordRepetition/adult/trial/Intro-AFTER-trail-exercises.mp3';

import nn_nw1 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord c 1.mp3';
import nn_nw2 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-2.mp3';
import nn_nw3 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-3.mp3';
import nn_nw4 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-4.mp3';
import nn_nw5 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-5.mp3';
import nn_nw6 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-6.mp3';
import nn_nw7 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-7.mp3';
import nn_nw8 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-8.mp3';
import nn_nw9 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-9.mp3';
import nn_nw10 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-10.mp3';
import nn_nw11 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-11.mp3';
import nn_nw12 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-12.mp3';
import nn_nw13 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-13.mp3';
import nn_nw14 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-14.mp3';
import nn_nw15 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-15.mp3';
import nn_nw16 from '../../assets/sounds/se/nonwordRepetition/child/test/nonord-c-16.mp3';

// NN “say the word again” for test
import nn_sayAgainTest from '../../assets/sounds/se/nonwordRepetition/child/test/Repeat-the-word-kan-du-seie-orde.mp3';

// ---------- TRIAL (NN) ----------
import nn_trial1 from '../../assets/sounds/se/nonwordRepetition/child/trial/exersices/TRIAL1.mp3';
import nn_trialCorrectAll from '../../assets/sounds/se/nonwordRepetition/child/trial/exersices/TRIAL if-correct.mp3';
import nn_trial1Wrong from '../../assets/sounds/se/nonwordRepetition/child/trial/exersices/TRIAL-1-if-wrong.mp3';
import nn_trial1Wrong10s from '../../assets/sounds/se/nonwordRepetition/child/trial/exersices/TRIAL-1-if-wrong-after-10-sec.mp3';
import nn_trial1NoAnswer10s from '../../assets/sounds/se/nonwordRepetition/child/trial/exersices/TRIAL-1-unanswered-10-sec.mp3';

import nn_sayAgainTrial from '../../assets/sounds/se/nonwordRepetition/child/trial/Repeat-the-word-kan-du-seie-orde.mp3';
import nn_introAfterTrial from '../../assets/sounds/se/nonwordRepetition/child/trial/Intro-after-trial.mp3';

import y_nw1 from '../../assets/sounds/se/nonwordRepetition/youth/test/1-Y.mp3';
import y_nw2 from '../../assets/sounds/se/nonwordRepetition/youth/test/2-Y.mp3';
import y_nw3 from '../../assets/sounds/se/nonwordRepetition/youth/test/3-Y.mp3';
import y_nw4 from '../../assets/sounds/se/nonwordRepetition/youth/test/4-Y.mp3';
import y_nw5 from '../../assets/sounds/se/nonwordRepetition/youth/test/5-Y.mp3';
import y_nw6 from '../../assets/sounds/se/nonwordRepetition/youth/test/6-Y.mp3';
import y_nw7 from '../../assets/sounds/se/nonwordRepetition/youth/test/7-Y.mp3';
import y_nw8 from '../../assets/sounds/se/nonwordRepetition/youth/test/8-Y.mp3';
import y_nw9 from '../../assets/sounds/se/nonwordRepetition/youth/test/9-Y.mp3';
import y_nw10 from '../../assets/sounds/se/nonwordRepetition/youth/test/10-Y.mp3';
import y_nw11 from '../../assets/sounds/se/nonwordRepetition/youth/test/11-Y.mp3';
import y_nw12 from '../../assets/sounds/se/nonwordRepetition/youth/test/12-Y.mp3';
import y_nw13 from '../../assets/sounds/se/nonwordRepetition/youth/test/13-Y.mp3';
import y_nw14 from '../../assets/sounds/se/nonwordRepetition/youth/test/14-Y.mp3';
import y_nw15 from '../../assets/sounds/se/nonwordRepetition/youth/test/15-Y.mp3';
import y_nw16 from '../../assets/sounds/se/nonwordRepetition/youth/test/16-Y.mp3';

import y_trial1 from '../../assets/sounds/se/nonwordRepetition/youth/trial/Trial1.mp3';
import y_trial1Correct from '../../assets/sounds/se/nonwordRepetition/youth/trial/Trial1-if-correct.mp3';
import y_trial1Wrong from '../../assets/sounds/se/nonwordRepetition/youth/trial/Trial1-if-wrong.mp3';
import y_trial1NoAnswer10s from '../../assets/sounds/se/nonwordRepetition/youth/trial/trial1-after-10-sek-if-unanswered.mp3';
import y_trial1Wrong10s from '../../assets/sounds/se/nonwordRepetition/youth/trial/trial1-after-10-sek-if-wrong.mp3';

import nn_y_nw1 from '../../assets/sounds/se/nonwordRepetition/youth/test/1-Y.mp3';
import nn_y_nw2 from '../../assets/sounds/se/nonwordRepetition/youth/test/2-Y.mp3';
import nn_y_nw3 from '../../assets/sounds/se/nonwordRepetition/youth/test/3-Y.mp3';
import nn_y_nw4 from '../../assets/sounds/se/nonwordRepetition/youth/test/4-Y.mp3';
import nn_y_nw5 from '../../assets/sounds/se/nonwordRepetition/youth/test/5-Y.mp3';
import nn_y_nw6 from '../../assets/sounds/se/nonwordRepetition/youth/test/6-Y.mp3';
import nn_y_nw7 from '../../assets/sounds/se/nonwordRepetition/youth/test/7-Y.mp3';
import nn_y_nw8 from '../../assets/sounds/se/nonwordRepetition/youth/test/8-Y.mp3';
import nn_y_nw9 from '../../assets/sounds/se/nonwordRepetition/youth/test/9-Y.mp3';
import nn_y_nw10 from '../../assets/sounds/se/nonwordRepetition/youth/test/10-Y.mp3';
import nn_y_nw11 from '../../assets/sounds/se/nonwordRepetition/youth/test/11-Y.mp3';
import nn_y_nw12 from '../../assets/sounds/se/nonwordRepetition/youth/test/12-Y.mp3';
import nn_y_nw13 from '../../assets/sounds/se/nonwordRepetition/youth/test/13-Y.mp3';
import nn_y_nw14 from '../../assets/sounds/se/nonwordRepetition/youth/test/14-Y.mp3';
import nn_y_nw15 from '../../assets/sounds/se/nonwordRepetition/youth/test/15-Y.mp3';
import nn_y_nw16 from '../../assets/sounds/se/nonwordRepetition/youth/test/16-Y.mp3';

import nn_y_trial1 from '../../assets/sounds/se/nonwordRepetition/youth/trial/exersices/TRIAL1.mp3';
import nn_y_trial1Correct from '../../assets/sounds/se/nonwordRepetition/youth/trial/exersices/if-correct.mp3';
import nn_y_trial1Wrong from '../../assets/sounds/se/nonwordRepetition/youth/trial/exersices/TRIAL1if-wrong.mp3';
import nn_y_trial1NoAnswer10s from '../../assets/sounds/se/nonwordRepetition/youth/trial/exersices/TRIAL1-answered-after-10-sec.mp3';
import nn_y_trial1Wrong10s from '../../assets/sounds/se/nonwordRepetition/youth/trial/exersices/TRIAL1-if-wrong-after-10-sec.mp3'; */

import a_nw1 from '../../assets/sounds/se/nonwordRepetition/adult/test/1.mp3';
import a_nw2 from '../../assets/sounds/se/nonwordRepetition/adult/test/2.mp3';
import a_nw3 from '../../assets/sounds/se/nonwordRepetition/adult/test/3.mp3';
import a_nw4 from '../../assets/sounds/se/nonwordRepetition/adult/test/4.mp3';
import a_nw5 from '../../assets/sounds/se/nonwordRepetition/adult/test/5.mp3';
import a_nw6 from '../../assets/sounds/se/nonwordRepetition/adult/test/6.mp3';
import a_nw7 from '../../assets/sounds/se/nonwordRepetition/adult/test/7.mp3';
import a_nw8 from '../../assets/sounds/se/nonwordRepetition/adult/test/8.mp3';
import a_nw9 from '../../assets/sounds/se/nonwordRepetition/adult/test/9.mp3';
import a_nw10 from '../../assets/sounds/se/nonwordRepetition/adult/test/10.mp3';
import a_nw11 from '../../assets/sounds/se/nonwordRepetition/adult/test/11.mp3';
import a_nw12 from '../../assets/sounds/se/nonwordRepetition/adult/test/12.mp3';
import a_nw13 from '../../assets/sounds/se/nonwordRepetition/adult/test/13.mp3';
import a_nw14 from '../../assets/sounds/se/nonwordRepetition/adult/test/14.mp3';
import a_nw15 from '../../assets/sounds/se/nonwordRepetition/adult/test/15.mp3';
import a_nw16 from '../../assets/sounds/se/nonwordRepetition/adult/test/16.mp3';

import a_trial1 from '../../assets/sounds/se/nonwordRepetition/adult/trial/Trial1.mp3';
import a_trial1Correct from '../../assets/sounds/se/nonwordRepetition/adult/trial/Trial1-if-correct.mp3';
import a_trial1Wrong from '../../assets/sounds/se/nonwordRepetition/adult/trial/Trial1-if-wrong.mp3';
import a_trial1NoAnswer10s from '../../assets/sounds/se/nonwordRepetition/adult/trial/trial1-after-10-sek-if-unanswered.mp3';
import a_trial1Wrong10s from '../../assets/sounds/se/nonwordRepetition/adult/trial/trial1-after-10-sek-if-wrong.mp3';

/* import nn_a_nw1 from '../../assets/sounds/se/nonwordRepetition/adult/test/1.mp3';
import nn_a_nw2 from '../../assets/sounds/se/nonwordRepetition/adult/test/2.mp3';
import nn_a_nw3 from '../../assets/sounds/se/nonwordRepetition/adult/test/3.mp3';
import nn_a_nw4 from '../../assets/sounds/se/nonwordRepetition/adult/test/4.mp3';
import nn_a_nw5 from '../../assets/sounds/se/nonwordRepetition/adult/test/5.mp3';
import nn_a_nw6 from '../../assets/sounds/se/nonwordRepetition/adult/test/6.mp3';
import nn_a_nw7 from '../../assets/sounds/se/nonwordRepetition/adult/test/7.mp3';
import nn_a_nw8 from '../../assets/sounds/se/nonwordRepetition/adult/test/8.mp3';
import nn_a_nw9 from '../../assets/sounds/se/nonwordRepetition/adult/test/9.mp3';
import nn_a_nw10 from '../../assets/sounds/se/nonwordRepetition/adult/test/10.mp3';
import nn_a_nw11 from '../../assets/sounds/se/nonwordRepetition/adult/test/11.mp3';
import nn_a_nw12 from '../../assets/sounds/se/nonwordRepetition/adult/test/12.mp3';
import nn_a_nw13 from '../../assets/sounds/se/nonwordRepetition/adult/test/13.mp3';
import nn_a_nw14 from '../../assets/sounds/se/nonwordRepetition/adult/test/14.mp3';
import nn_a_nw15 from '../../assets/sounds/se/nonwordRepetition/adult/test/15.mp3';
import nn_a_nw16 from '../../assets/sounds/se/nonwordRepetition/adult/test/16.mp3';

import nn_a_trial1 from '../../assets/sounds/se/nonwordRepetition/adult/trial/exersices/Trial1.mp3';
import nn_a_trial1Correct from '../../assets/sounds/se/nonwordRepetition/adult/trial/exersices/Trial1-if-correct.mp3';
import nn_a_trial1Wrong from '../../assets/sounds/se/nonwordRepetition/adult/trial/exersices/Trial1-if-wrong.mp3';
import nn_a_trial1NoAnswer10s from '../../assets/sounds/se/nonwordRepetition/adult/trial/exersices/trial1-after-10-sek-if-unanswered.mp3';
import nn_a_trial1Wrong10s from '../../assets/sounds/se/nonwordRepetition/adult/trial/exersices/trial1-after-10-sek-if-wrong.mp3'; */

export const OBJECT_IMAGE_MAP = {
	hus: imgHouse,
	elephants: imgBag,
	loins: imgWhale,
	crocodiles: imgSheep,
	giraffe: imgGiraffe,
	orange: imgOrange,
	pære: imgPear,
	ananas: imgPineapple,
	druer: imgGrapes,
	blomst: imgFlower,
	hund: imgDog,
	katt: imgCat,
	biler: imgCars,
	bilerOgSykkel: imgCarsBike,
	buss: imgBus,
	bøker: imgBooks,
	fugl: imgBird,
	banan: imgBanana,
	ball: imgBall,
	eple: imgApple,
};

export const SHAPE_IMAGE_MAP = {
	triangle: imgTriangle,
	square: imgSquare,
	circle: imgCircle,
	// rectangle: some image if you have one – else we’ll keep CSS fallback
};

// ---------- HELPERS ----------

const mk = (url) => new Howl({src: [url], preload: true, html5: true});

const objFromArray = (urls) =>
	urls.reduce((acc, url, i) => {
		acc[i] = mk(url);
		return acc;
	}, {});

// ---------- EXPORTED PACKS ----------

// Packs for NO child
/* export const no_nonword_child_test = objFromArray([
	nw1,
	nw3,
	nw5,
	nw7,
	nw8,
	nw9,
	nw12,
	nw13,
	nw15,
	nw16,
]);


export const no_nonword_child_trial = {
	stimulus: mk(trial1),
	sayAgain: mk(sayAgainTrial),
	correct: mk(trial1Correct),
	wrong: mk(trial1Wrong),
	noAnswer10s: mk(trial1NoAnswer10s),
	wrong10s: mk(trial1Wrong10s),
	introAfter: mk(introAfterTrial),
};

export const nn_nonword_child_test = objFromArray([
	nn_nw1,
	nn_nw3,
	nn_nw5,
	nn_nw7,
	nn_nw8,
	nn_nw9,
	nn_nw12,
	nn_nw13,
	nn_nw15,
	nn_nw16,
]);

export const nn_nonword_child_sayAgain = mk(nn_sayAgainTest);

export const nn_nonword_child_trial = {
	stimulus: mk(nn_trial1),
	sayAgain: mk(nn_sayAgainTrial),
	// "(for all) TRAIL if-correct" is used as generic correct–feedback
	correct: mk(nn_trialCorrectAll),
	wrong: mk(nn_trial1Wrong),
	noAnswer10s: mk(nn_trial1NoAnswer10s),
	wrong10s: mk(nn_trial1Wrong10s),
	introAfter: mk(nn_introAfterTrial),
};

export const no_nonword_youth_test = objFromArray([
	y_nw1,
	y_nw2,
	y_nw4,
	y_nw5,
	y_nw7,
	y_nw8,
	y_nw9,
	y_nw10,
	y_nw11,
	y_nw12,
	y_nw15,
	y_nw16,
]);

export const no_nonword_youth_trial = {
	stimulus: mk(y_trial1),
	sayAgain: mk(sayAgainTrial),
	correct: mk(y_trial1Correct),
	wrong: mk(y_trial1Wrong),
	noAnswer10s: mk(y_trial1NoAnswer10s),
	wrong10s: mk(y_trial1Wrong10s),
};

export const nn_nonword_youth_test = objFromArray([
	nn_y_nw1,
	nn_y_nw2,
	nn_y_nw4,
	nn_y_nw5,
	nn_y_nw7,
	nn_y_nw8,
	nn_y_nw9,
	nn_y_nw10,
	nn_y_nw11,
	nn_y_nw12,
	nn_y_nw15,
	nn_y_nw16,
]);

export const nn_nonword_youth_trial = {
	stimulus: mk(nn_y_trial1),
	sayAgain: mk(nn_sayAgainTrial),
	correct: mk(nn_y_trial1Correct),
	wrong: mk(nn_y_trial1Wrong),
	noAnswer10s: mk(nn_y_trial1NoAnswer10s),
	wrong10s: mk(nn_y_trial1Wrong10s),
}; */

export const no_nonword_adult_test = objFromArray([
	a_nw1,
	a_nw2,
	a_nw3,
	a_nw4,
	a_nw5,
	a_nw6,
	a_nw7,
	a_nw8,
	a_nw9,
	a_nw10,
	a_nw11,
	a_nw12,
	a_nw13,
]);

export const no_nonword_adult_trial = {
	stimulus: mk(a_trial1),
	sayAgain: mk(sayAgainTrial),
	correct: mk(a_trial1Correct),
	wrong: mk(a_trial1Wrong),
	noAnswer10s: mk(a_trial1NoAnswer10s),
	wrong10s: mk(a_trial1Wrong10s),
};

/* export const nn_nonword_adult_test = objFromArray([
	nn_a_nw1,
	nn_a_nw3,
	nn_a_nw4,
	nn_a_nw5,
	nn_a_nw6,
	nn_a_nw7,
	nn_a_nw8,
	nn_a_nw9,
	nn_a_nw10,
	nn_a_nw12,
	nn_a_nw13,
	nn_a_nw16,
]);

export const nn_nonword_adult_trial = {
	stimulus: mk(nn_a_trial1),
	sayAgain: mk(nn_sayAgainTrial),
	correct: mk(nn_a_trial1Correct),
	wrong: mk(nn_a_trial1Wrong),
	noAnswer10s: mk(nn_a_trial1NoAnswer10s),
	wrong10s: mk(nn_a_trial1Wrong10s),
}; */

export const no_nonword_adult_sayAgain = mk(sayAgainTest);

export const getChildTestPack = (langCode, testKeyType) => {
	const isNN = langCode === 'nn';
	const tk = String(testKeyType || '').toLowerCase();

	const isYouth = tk.includes('youth') || tk.includes('ungdom');
	const isAdult = tk.includes('adult') || tk.includes('voksen');


	if (isAdult) {
		return  no_nonword_adult_test;
	}

	return  no_nonword_adult_test;
};

export const getChildSayAgain = (langCode) =>
	langCode === 'nn' ? no_nonword_adult_sayAgain : no_nonword_adult_sayAgain;

export const getChildTrialPack = (langCode, testKeyType) => {
	const isNN = langCode === 'nn';
	const tk = String(testKeyType || '').toLowerCase();

	const isYouth = tk.includes('youth') || tk.includes('ungdom');
	const isAdult = tk.includes('adult') || tk.includes('voksen');

	// Youth followup
	if (isYouth) {
		// For now we only have NO youth; NN falls back to child NN
		if (isNN) return no_nonword_adult_trial;
		return no_nonword_adult_trial;
	}

	// Adult followup – for now just fall back to child packs
	if (isAdult) {
		return isNN ? no_nonword_adult_trial : no_nonword_adult_trial;
	}

	// Default = child followup
	return isNN ? no_nonword_adult_trial : no_nonword_adult_trial;
};

export const noDistractionsSounds = {
	distraction1: noDistraction1ClapHandsAsShownOnScreen,
	distraction2: noDistraction2SayColoursAsShownOnScreen,
	distraction3: noDistraction3SayNumberAsShownOnScreen,
	distraction4: noDistraction4FourThingsWithSameShapeAsShownOnScreen,
	distraction5: noDistraction5NameFourAnimalsQuckly,
	distraction6: noDistraction6ThreeSameColoursItemsAsShownOnScreen,
	distraction7: noDistraction7NameItemsAsShownOnScreen,
	distraction8: noDistraction8CorrectOrderFromBigToSmall,
	distraction9: noDistraction9SolveAssignmnet,
};

/* export const nnDistractionsSounds = {
	distraction1: nnDistraction1ClapHandsAsShownOnScreen,
	distraction2: nnDistraction2SayColoursAsShownOnScreen,
	distraction3: noDistraction3SayNumberAsShownOnScreen,
	distraction4: nnDistraction4FourThingsWithSameShapeAsShownOnScreen,
	distraction5: nnDistraction5NameFourAnimalsQuckly,
	distraction6: nnDistraction6ThreeSameColoursItemsAsShownOnScreen,
	distraction7: nnDistraction7NameItemsAsShownOnScreen,
	distraction8: nnDistraction8CorrectOrderFromBigToSmall,
	distraction9: nnDistraction9SolveAssignmnet,
}; */
